import {
  Box,
  Button,
  CurrencyInput,
  Form,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Spacer,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { format } from 'date-fns'
import { defineMessages, useIntl } from 'react-intl'
import { HomeownerDigestTrackingEventLocation } from '../../../../constants/tracking'
import { SlideOnMount } from '../../../shared/Animations'

const Slide = props => <SlideOnMount interval={50} top='-80px' {...props} />

const MSG = defineMessages({
  heading: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.heading',
    defaultMessage: 'Tell us about you appraisal'
  },
  subheading: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.subheading',
    defaultMessage: "You're so close to seeing your home's estimated value and equity insights!"
  },
  submit: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.submit',
    defaultMessage: 'Continue'
  },
  appraisalValueLabel: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.appraisalValueLabel',
    defaultMessage: 'Appraisal Value'
  },
  appraisalValueRequiredError: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.appraisalValueRequiredError',
    defaultMessage: "Enter your home's appraisal value"
  },
  appraisalDateLabel: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.appraisalDateLabel',
    defaultMessage: 'Appraisal Date'
  },
  appraisalDateRequiredError: {
    id: 'HomePriceIndexWizard.steps.appraisalDetails.appraisalDateRequiredError',
    defaultMessage: "Enter your home's appraisal date"
  }
})

export const AppraisalDetails = ({ onComplete }) => {
  const intl = useIntl()
  const today = format(new Date(), 'yyyy-MM-dd')

  return (
    <Form onSubmit={onComplete} flex='1' display='flex' flexDirection='column' justifyContent='space-between'>
      {({ formState: { errors } }) => (
        <>
          <Slide>
            <Heading>{intl.formatMessage(MSG.heading)}</Heading>
            <Text>{intl.formatMessage(MSG.subheading)}</Text>
          </Slide>
          <Slide>
            <Box marginTop='12'>
              <FormControl isInvalid={!!errors?.appraisedValue}>
                <FormLabel>{intl.formatMessage(MSG.appraisalValueLabel)}</FormLabel>
                <CurrencyInput
                  name='appraisedValue'
                  rules={{
                    required: {
                      value: true,
                      message: intl.formatMessage(MSG.appraisalValueRequiredError)
                    }
                  }}
                  tracking={{
                    guid: 'bgnyEvvyC2KaxFtdV5SMtQ',
                    descriptor: MSG.appraisalValueLabel.defaultMessage,
                    ui_context:
                      HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_APPRAISAL_DETAILS_STEP
                  }}
                />
                <FormErrorMessage>{errors?.appraisedValue?.message?.toString()}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={!!errors?.appraisedDate}>
                <FormLabel>{intl.formatMessage(MSG.appraisalDateLabel)}</FormLabel>
                <Input
                  type='date'
                  max={today}
                  name='appraisedDate'
                  rules={{
                    required: {
                      value: true,
                      message: intl.formatMessage(MSG.appraisalDateRequiredError)
                    }
                  }}
                  tracking={{
                    guid: 'sVb6su4n2LJVCAkfu4ZghB',
                    descriptor: MSG.appraisalDateLabel.defaultMessage,
                    ui_context:
                      HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_APPRAISAL_DETAILS_STEP
                  }}
                />
                <FormErrorMessage>{errors?.appraisedDate?.message?.toString()}</FormErrorMessage>
              </FormControl>
            </Box>
          </Slide>
          <Spacer />
          <Slide>
            <Button
              type='submit'
              colorScheme='primary'
              width='100%'
              tracking={{
                guid: 'xwerVQc7iKv95WTucWkMA8',
                descriptor: MSG.submit.defaultMessage,
                ui_context:
                  HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_APPRAISAL_DETAILS_STEP
              }}
            >
              {intl.formatMessage(MSG.submit)}
            </Button>
          </Slide>
        </>
      )}
    </Form>
  )
}
